import {FeatureFlag} from "@services/featureFlagConstants";
import {QA, SectionDivider} from "src/components/v5/Faq/Faq";
import {useFaqIndex} from "src/hooks/useFaqIndex";

import {useFeatureFlag} from "../hooks/useFeatureFlags";

export const PHONE_NUMBERS = {
  REASON: "(415) 877-9821",
  MAIN: "(415) 877-4963",
};

const useInsurancePricingConstants = (): {
  faq: (QA | SectionDivider)[];
} => {
  const HRSA_FAQ_CHANGES_ENABLED = useFeatureFlag<boolean>(
    FeatureFlag.GROWTH_HRSA_FAQ_CHANGES_ENABLED,
  );

  const faq = useFaqIndex([
    HRSA_FAQ_CHANGES_ENABLED
      ? "How much does COVID-19 testing, treatment, and vaccines cost?"
      : "How much does COVID-19 testing cost?",
    "Do you accept insurance?",
    "How much will my co-pay be?",
    "What are co-pays? What are deductibles?",
    "What does it mean if my insurance is not verified?",
    "How do I add my insurance if I'm on my family's plan?",
    "When will I get my bill?",
    "My credit card was charged by 'direct urgent care'",
  ]);

  return {
    faq,
  };
};

export default useInsurancePricingConstants;
